export default __webpack_public_path__ + "static/media/IconConvertToExcel.0a97c4b6.png";